<template>
  <div>
    <br />
    <b-row class="row not-print" style="margin-left: 4px">
      <b-col>
        <form @keyup.enter="search()" @submit.prevent>
          <div class="row pt-3">
            <div class="col-4">
              <text-input
                v-model="searchForm.text"
                placeholder="Pesquisar"
                v-debounce:100ms="search"
              />
            </div>
            <div class="col-6">
              <button
                type="button"
                class="btn btn-sm btn-primary mr-3"
                @click="showFilters = !showFilters"
              >
                <i class="fas fa-filter" /> Mais Filtros
              </button>
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="search()"
              >
                <i class="fas fa-search" /> Pesquisar
              </button>
            </div>

            <div class="col text-right mr-4">
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click="print()"
              >
                <i class="fas fa-print mr-1" /> Imprimir
              </button>
            </div>
          </div>
          <b-collapse v-model="showFilters">
            <b-row>
              <b-col cols="2" class="mt-2" align-self="center">
                <b-button @click="clear()" class="x-small" size="sm">
                  <i class="fas fa-times" /> Limpar Filtro
                </b-button>
              </b-col>
              <b-col cols="2">
                <date-input
                  v-model="searchForm.due_date_start"
                  alias="Vencimento de"
                />
              </b-col>
              <b-col cols="2">
                <date-input
                  v-model="searchForm.due_date_end"
                  alias="Vencimento até"
                />
              </b-col>

              <b-col align-self="center">
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="search()"
                  :value="'o'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Em Aberto</small>
                </b-form-checkbox>
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="search()"
                  :value="'p'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Pagos</small>
                </b-form-checkbox>
                <b-form-checkbox
                  class="d-block d-md-inline"
                  switch
                  inline
                  @change="search()"
                  :value="'c'"
                  :unchecked-value="''"
                  v-model="searchForm.status"
                >
                  <small>Cancelados</small>
                </b-form-checkbox>
              </b-col>
            </b-row>
          </b-collapse>
        </form>
      </b-col>
    </b-row>

    <div class="row" style="margin: 3px">
      <div class="col">
        <b-card title="Relatório  Contas a Pagar">
          <div class="row">
            <div
              class="col"
              v-if="searchForm.due_date_start || searchForm.due_date_end"
            >
              <span v-if="searchForm.due_date_start">
                Vencimento de: {{ searchForm.due_date_start | dateBr }}
              </span>
              <br />

              <span v-if="searchForm.due_date_end">
                Vencimento até: {{ searchForm.due_date_end | dateBr }}
              </span>
            </div>
          </div>
          <br />
          <div class="mr-2 row">
            <div class="col">
              <span class="font-weight-bold">Contas canceladas : </span
              >{{ totalBillCanceled | moneyBr }}
            </div>
            <div class="col">
              <span class="font-weight-bold">Contas pagas : </span
              >{{ totalBillPaid | moneyBr }}
            </div>
            <div class="col">
              <span class="font-weight-bold">Contas em Aberto : </span
              >{{ totalBillOpen | moneyBr }}
            </div>

            <div class="col">
              <span class="font-weight-bold">Consulta Realizada :</span>
              {{ date | dateTimeBr }}
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row" style="margin: 3px">
      <div class="col">
        <div class="card">
          <table class="table">
            <thead>
              <tr>
                <th style="text-align: start; width: 30%" scope="col">
                  Fornecedor / Descrição
                </th>
                <th style="text-align: center; width: 15%" scope="col">
                  Plano de contas
                </th>
                <th style="text-align: end; width: 10%" scope="col">Valor</th>
                <th style="text-align: end; width: 15%" scope="col">
                  Saldo Devedor
                </th>
                <th style="text-align: center; width: 10%" scope="col">
                  Vencimento
                </th>
                <th style="text-align: center; width: 10%" scope="col">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in bills" :key="index">
                <td>{{ row.vendor_description }} | {{ row.description }}</td>
                <td style="text-align: center">
                  {{ row.account_plan_description }}
                </td>
                <td class="text-right">
                  {{ row.value | moneyBr }}
                </td>
                <td class="text-right">
                  {{ (row.value - row.received_value) | moneyBr }}
                </td>
                <td style="text-align: center">
                  <due-date-badge ref="DueDateBadge" :date="row.due_date" />
                </td>
                <td style="text-align: center">
                  <span
                    :class="['badge', 'text-white', status[row.status].class]"
                    style="line-height: 1.2"
                    >{{ status[row.status].text }}</span
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CollapseOfTheBillReceivebleFilter from "../../components/billReceiveble/filter/CollapseOfTheBillReceivebleFilter";
import BillReceivebleStatsCard from "../../components/billReceiveble/sections/BillReceivebleStatsCard.vue";
import DueDateBadge from "../../components/ui/DueDateBadge.vue";
export default {
  props: {},
  components: {
    CollapseOfTheBillReceivebleFilter,
    BillReceivebleStatsCard,
    DueDateBadge,
  },

  data() {
    return {
      showFilters: false,
      searchForm: {
        text: null,
        due_date_start: null,
        due_date_end: null,
        status: ["o"],
      },

      totalBillRenegotiated: null,
      totalBillCanceled: null,
      totalBillPaid: null,
      totalBillOpen: null,
      bills: {},

      status: {
        o: {
          text: "Em Aberto",
          class: "badge-primary",
        },

        p: {
          text: "Pago",
          class: "badge-success",
        },

        c: {
          text: "Cancelado",
          class: "badge-danger",
        },

        r: {
          text: "Renegociado",
          class: "badge-warning",
        },
      },
    };
  },
  mounted() {
    this.$store.commit("pageHasLoaded");
    this.search();
  },
  computed: {
    date() {
      return moment().format();
    },
  },
  methods: {
    search(page = 1) {
      this.$store.commit("showLoading");
      axios;
      this.$store
        .dispatch("billpayable/getBillPayableReport", this.searchForm)
        .then((response) => {
          this.totalBillRenegotiated = response.data.billRenegotiated.value;
          this.totalBillCanceled = response.data.billCanceled.value;
          this.totalBillPaid = response.data.billPaid.value;
          this.totalBillOpen = response.data.billOpen.value;
          this.bills = response.data.billPayable;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
          this.error = error;
        });
    },

    clear() {
      this.searchForm.text = null;
      this.searchForm.status = ["o"];
      this.searchForm.due_date_end = null;
      this.searchForm.due_date_start = null;
      this.search();
    },

    print() {
      window.print();
    },
  },
};
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fafafa;
  color: rgb(0, 0, 0);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol";
  font-size: 11pt;
}

* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.page {
  width: 297mm;
  min-height: 210mm;
  padding: 0.5cm;
  margin: 0.5cm;
  border: 1px #d3d3d3 solid;
  /*    border-radius: 5px;*/
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.subpage {
  padding: 0cm;
  /*    border: 5px red solid;*/
  height: 256mm;
  outline: 2cm #ffeaea solid;
}

@page {
  size: A4;
  margin: 0.5cm;
  padding: 0.5cm;
}

@media print {
  .page {
    visibility: visible;
    margin: initial;
    border: rgba(0, 0, 0, 0.1);
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    page-break-after: always;
  }

  .not-print {
    display: none;
  }
}

hr.color {
  border: 1px solid black;
}
</style>